import { deserializePage, fetchPage } from 'supporticon/api/pages'
import { createAction } from 'supporticon/utils/actions'
import { createReducer } from 'supporticon/utils/reducers'
import { isJustGiving } from '../../lib/environment'

// Constants
const NAMESPACE = 'app/fundraisingPages'

// Selectors
export * from './selectors'

// Action
export const fetchFundraisingPage = (slug, campaign) => createAction({
  namespace: NAMESPACE,
  fetcher: isJustGiving() ? fetchJGPage(slug) : fetchEDHPage(slug, campaign)
})

const fetchJGPage = (slug) => fetchPage(slug, null, { includeFitness: true })

const fetchEDHPage = (slug, campaign) => {
  const params = {
    slug,
    campaignSlug: campaign.slug,
    countryCode: campaign.countryCode
  }

  return Promise.resolve()
    .then(() => fetchPage(params))
    .then(page => fetchPage(page.id))
}

// Reducer
const expandedDeserializePage = page => {
  const deserializedPage = deserializePage(page)

  return {
    ...deserializedPage,
    url: `/fundraising/${deserializedPage.slug}`,
    fitnessGoal: isJustGiving()
      ? parseInt(page.pageSummaryWhat)
      : deserializedPage.fitnessGoal
  }
}

export default createReducer({
  namespace: NAMESPACE,
  deserialize: expandedDeserializePage
})
